import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { updateCandidateCredentialingSpecialistFailure } from 'src/app/compliance/store/actions/compliance.actions';
import { ContractAssignmentService } from 'src/app/shared/services/contract-assignments.service';
import { CredentialingService } from '../../credentialing.service';
import {
    loadCredentialingPermissions,
    loadCredentialingPermissionsFailure,
    loadCredentialingPermissionsSuccess,
    updateCredentialingSpecialistFromCandidatesGrid,
    updateCredentialingSpecialistFromCandidatesGridSuccess
} from '../actions/credentialing.actions';

@Injectable()
export class CredentialingPermissionsEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _credentialingService: CredentialingService,
        private readonly _contractAssignmentService: ContractAssignmentService
    ) {}

    loadCredentialingPermissions$ = createEffect(() =>
        this._actions$.pipe(
            ofType(loadCredentialingPermissions),
            switchMap(() => {
                return this._credentialingService.getCredentialingPermissions().pipe(
                    map((res) => loadCredentialingPermissionsSuccess({ permissions: res })),
                    catchError((res) => of(loadCredentialingPermissionsFailure({ error: res })))
                );
            })
        )
    );

    updateCandidateAssignmentConfiguration$ = createEffect(() =>
        this._actions$.pipe(
            ofType(updateCredentialingSpecialistFromCandidatesGrid),
            switchMap((action) => {
                return this._contractAssignmentService
                    .updateCandidateAssignmentConfiguration(action.candidateId, action.assignmentChange)
                    .pipe(
                        map((res) => updateCredentialingSpecialistFromCandidatesGridSuccess({ updatedGridItem: res })),
                        catchError((error: unknown) => of(updateCandidateCredentialingSpecialistFailure({ error })))
                    );
            })
        )
    );
}
